import { apiClient, getAccessToken, removeAccessToken } from "./apiClient";

const LogoutAction = async () => {
    const accessToken = getAccessToken();
    const res = await apiClient({
        url: "/logout",
        method: "GET",
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true,
    });

    removeAccessToken();

    const parsedData = res?.data;

    return parsedData;
};

export default LogoutAction;
